/**
 * Agence'O - logo-slider
 * @author Guillaume Bouillon (Agence'O)
 * @created 14/05/2019
 */

(function ($) {

    $(document).click(function(event) {
      //if you click on anything except the modal itself or the "open modal" link, close the modal
      if (!$(event.target).closest(".open").length) {
        $('.js-filter').removeClass('open');
        $('.listing__filter__content').css('display','none');
      }
    });

    $('.listing__filter__item').click(function(event){
      var $el = $(this);
      var $value = $el.text();
      var $categoryType = $el.closest('.js-filter').attr('id').replace('filter-','');
      var $parent = $el.closest('.listing__filters');
      var $parentID = $parent.attr('id');
      var $parentFilters = $parentID.replace('js-filter-','');
      // console.log($parentFilters);
      // console.log($categoryType);
      // console.log($value);
      var categoryType = $categoryType;
      var categoryVal = $value;
      var categoryID = $el.data('tid');
      var $parentTriggerTitle = $el.closest('.js-filter');
      if( ! $parentTriggerTitle.hasClass('current') ){
        var siblingsEl = $parentTriggerTitle.siblings();
        siblingsEl.each(function(index, elem){
          var listName = $(elem).data('name-filter');
          $(elem).find('.js-trigger-title').html(listName);
        });

        $parentTriggerTitle.addClass('current');
        siblingsEl.removeClass('current');
        // console.log($parentTriggerTitle.data('name-filter'));
      }

      $parentTriggerTitle.removeClass('open');
      $('.listing__filter__content').css('display','none');

      if( $parentFilters === "carenews" ){

        var $carenews_news_listing_wrap = $("#js-carenews-listing");
        $carenews_news_listing_wrap.css('opacity',0.4);
        $parentTriggerTitle.find('.js-trigger-title').html(categoryVal);
        $.post('/front-page-news/block', { categoryType: categoryType, categoryVal: categoryID }, function( data ){
          var $htmlResponse = $(data).find("#js-carenews-listing").html();
          $('#js-carenews-listing').html($htmlResponse);
          $carenews_news_listing_wrap.css('opacity',1);
        });

      }else{

        var $actors_news_listing_wrap = $("#js-actors-listing");
        $actors_news_listing_wrap.css('opacity',0.4);
        $parentTriggerTitle.find('.js-trigger-title').html(categoryVal);
        $.post('/front-page-news-actors/block', { categoryType: $categoryType, categoryVal: categoryVal }, function( data ){
          var $htmlResponse = $(data).find("#js-actors-listing").html();
          $('#js-actors-listing').html($htmlResponse);
          $actors_news_listing_wrap.css('opacity',1);
        });

      }

    });

}(jQuery));
